import { queryOptions } from "@tanstack/react-query";
import * as chatApi from "./chat-api";

export const chatQueries = {
  all: () => ["chats"] as const,
  lists: () => [...chatQueries.all(), "list"] as const,
  roomLists: () => [...chatQueries.all(), "rooms"] as const,
  roomsByParent: (parentContainerId: string) =>
    queryOptions({
      queryKey: [...chatQueries.roomLists(), parentContainerId],
      queryFn: () => chatApi.listChatRooms(parentContainerId, "room"),
    }),
  messageRoomLists: () => [...chatQueries.all(), "message-rooms"] as const,
  messageRoomsByParent: (parentContainerId: string) =>
    queryOptions({
      queryKey: [...chatQueries.messageRoomLists(), parentContainerId],
      queryFn: () => chatApi.listChatRooms(parentContainerId, "message_room"),
    }),
  lastMessagesForRooms: (roomIds: string[]) =>
    queryOptions({
      queryKey: [...chatQueries.roomLists(), "lastMessages", roomIds],
      queryFn: () => chatApi.listLastMessagesForRooms(roomIds),
    }),
  memberNamesForRooms: (roomIds: string[]) =>
    queryOptions({
      queryKey: [...chatQueries.messageRoomLists(), "memberNames", roomIds],
      queryFn: () => chatApi.listMemberNamesForRooms(roomIds),
    }),
  byRoom: (roomName: string) =>
    queryOptions({
      queryKey: [...chatQueries.lists(), roomName],
      queryFn: () => chatApi.getMessages(roomName),
    }),
  byMessageId: (messageId: string) =>
    queryOptions({
      queryKey: [...chatQueries.lists(), messageId],
      queryFn: () => chatApi.getMessage(messageId),
    }),
  // CR-141: a room's queued/running/failed durable AI turns.
  aiTurns: (roomId: string) =>
    queryOptions({
      queryKey: [...chatQueries.all(), "ai-turns", roomId],
      queryFn: () => chatApi.listOpenAiTurns(roomId),
    }),
  subscriptions: () => [...chatQueries.all(), "subscription"] as const,
  aiTurnSubscription: (roomId: string) =>
    [...chatQueries.subscriptions(), "ai-turns", roomId] as const,
  subscription: (roomName: string) => [...chatQueries.subscriptions(), roomName],
};
